
/** Normalize strings and handle nullish values */
function normalize(value) {
  if (value == null) return null;
  return typeof value === "string" ? value.trim() : value;
}

/** Compact an options array into a stable comparable structure */
function compactOptions(options = []) {
  return (options || []).map((o) => ({
    index: o.index,
    checked: !!o.checked,
    notes: typeof o.notes === "string" ? o.notes.trim() : o.notes ?? null,
    answer: normalize(o.answer),
  }));
}

/** Extract comparable parts of a question */
function comparableQuestion(q = {}) {
  return {
    id: q.id ?? null,
    select: q.select ?? null,
    answer: normalize(q.answer),
    value: normalize(q.value), // used by Paragraph / Text area fields
    options: compactOptions(q.options),
    signature: q.signature || null,
  };
}

/** Deep equality check for two questions */
function isSameQuestion(a, b) {
  return JSON.stringify(comparableQuestion(a)) === JSON.stringify(comparableQuestion(b));
}

/**
 * Compare two form structures and return:
 * - count: number of changed questions
 * - changes: detailed list of changed questions
 */
export function diffForm(originalTabs = [], currentTabs = []) {
  const changes = [];
  const tabCount = Math.max(originalTabs.length, currentTabs.length);

  for (let ti = 0; ti < tabCount; ti++) {
    const oTab = originalTabs[ti] || { content: [] };
    const cTab = currentTabs[ti] || { content: [] };
    const qCount = Math.max(oTab.content?.length || 0, cTab.content?.length || 0);

    for (let qi = 0; qi < qCount; qi++) {
      const oq = oTab.content?.[qi];
      const cq = cTab.content?.[qi];

      if (!isSameQuestion(oq, cq)) {
        changes.push({
          tabIndex: ti,
          questionIndex: qi,
          questionId: cq?.id ?? oq?.id ?? null,
          type: cq?.select ?? oq?.select ?? null,
          before: comparableQuestion(oq),
          after: comparableQuestion(cq),
        });
      }
    }
  }

  return { count: changes.length, changes };
}
